@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.edit-columns-modal {
  width: 375px;
  max-height: 80vh;
}

.column-option {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    .pin-unpin-button {
      display: inline;
    }
    .pinned-text {
      display: none;
    }
  }
}

.pin-unpin-button {
  font-size: 13px;
  display: none;
}

.pinned-text {
  font-size: 13px;
  color: @edit-columns-modal--pinned-text--text-color;
}

.edit-columns-selectors {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 5px;
}

.deselect-all {
  font-size: 12px;
}
